<template>
  <v-container>
    <v-layout row wrap fill-height>
      <v-flex lg6 md6 sm12 xs12 :class="['pa-2', 'text-xs-center']">
        <v-card :class="['full-height', 'pt-3']">
          <v-card-text :class="['py-4']">
            <span :class="['avatar-wrapper', 'elevation-12', 'my-4']">
              <v-avatar size="256">
                <v-img @click="showImageInLightbox($config.aboutPagePhoto)" :lazy-src="$config.replacementImage" :class="['bw-image-filter']" :src="$config.aboutPagePhoto" :alt="$config.aboutPagePhoto" />
              </v-avatar>
            </span>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex lg6 md6 sm12 xs12 :class="['pa-2']">
        <v-card :class="['full-height']">
          <v-card-text>
            <static-page-content slug="about" :class="['title', 'font-weight-light', 'about']" />
          </v-card-text>
        </v-card>
      </v-flex>
      <featured-video />
    </v-layout>
    <news-ticker />
  </v-container>
</template>
<script>
import methods from '../mixins/methods'

export default {
  name: 'PageAbout',
  mixins: [
    methods
  ]
}
</script>
<style>
.about p
{
  line-height: 1.5em;
}
</style>



// WEBPACK FOOTER //
// src/pages/about.vue